import React from 'react';
import { injectIntl } from "react-intl";
import AppService, { Utilities } from "s2s-app-service";
import PropTypes from 'prop-types';
import SoftPhone from '../components/softphone';
import useCallInfo from "../hooks/callInfo";
//import { useStore } from "../js/store";
import { track } from 's2s-app-service';
import { processServiceErrorsToAlerts } from '../js/utilities';
import useAlerts from '../hooks/alerts';

const callProgress = injectIntl((props) => {

  // console.warn('****************** callProgress ROUTE render');

  // const [theStore] = useStore();

  const [callInfo, { makeCall, muteCall, hangupCall, setActiveCallId, holdCall, sendDtmf, blindTransfer, attendedTransfer, initiateTransfer, cancelTransfer, setIsMergingCall, mergeCalls }] = useCallInfo();
  const [, { createErrorAlert }] = useAlerts();
  //console.log('callprogress ', props, theStore);
  const refreshDevices = () => {
    // TODO write this....
    console.log('Refresh devices in appmain');
  };

  const userAction = (action, data, event) => {

    // console.log('userAction callback in callProgress', action, data, props, event);
    switch (action) {
      case "hangup":
        // TODO setActiveCallId(data.id);
        //console.log('>>>>1111111>>>>>>', action, data, event)


        hangupCall(data, props.intl);

        break;

      case "voicemail":
        {
          try {
            // get the vm extension and call it....
            let vmNumber = Utilities.getDialPlanOptions(AppService.getInstance().getConnectData().dialplan_options.customerfeaturecodes, "VM Extension");
            if (vmNumber.length > 0) {
              makeCall(vmNumber, props.intl);
            } else {
              throw {"message":"unable to find voicemail extension number"};
            }
          } catch (e) {
            console.error('error with voicemail: ', Utilities.formatError(e));
            const { alertHeading: message, alertBody } = processServiceErrorsToAlerts(Utilities.formatError(e));

            createErrorAlert({
              message,
              details: [alertBody],
              autoCloseTimeout: 10,
            });
          }
        }
        break;

      case "make-call":
        makeCall(data, props.intl);
        break;
      case "dtmf-dial":
        sendDtmf(callInfo.activeCallId, data, props.intl);
        break;

      case "blindTransfer":
        blindTransfer(data.callId, data.transferToNbr, props.intl);
        break;

      case "set-active-call":
        if (callInfo.activeCallId && data.id !== callInfo.activeCallId && !callInfo.inprogressCalls[callInfo.activeCallId].isHeld) {
          holdCall(callInfo.activeCallId, props.intl);
        }

        setActiveCallId(data.id);
        // props.history.push(`/callprogress/${data.id}`);
        break;
      case "hold":
        holdCall(callInfo.activeCallId, props.intl);
        break;
      case "mute":
        muteCall(callInfo.activeCallId, props.intl);
        break;

      case "merge":
        mergeCalls();
        break;  

      case "transfer":
        console.log('TRANSFER CLICKED');

        // put activeCallId on hold if it is not already
        if (!callInfo.inprogressCalls[callInfo.activeCallId].isHeld) {
          holdCall(callInfo.activeCallId, props.intl);
        }
        // now start transfer procedure
        initiateTransfer(callInfo.activeCallId);

        break;

      case "attendedTransfer":

        console.log('Attended Transfer Clicked', data);

        if (callInfo.activeCallId && !callInfo.inprogressCalls[callInfo.activeCallId].isHeld && data.id !== callInfo.activeCallId) {
          holdCall(callInfo.activeCallId, props.intl);
        }

        makeCall(data.transferToNbr, props.intl);

        break;

      case "complete-attended-transfer":

        console.log('COMPLETE ATT TRANS', callInfo);
        attendedTransfer({ 'callId': callInfo.transferCallId, 'toCallId': callInfo.transferDestinationCallId }, props.intl);
        break;

      case "cancelTransfer":
        console.log('CANCELTRANSFER CLICKED');
        // updateUserControlStatus('active');
        cancelTransfer();
        break;



      default:
      // props.history.push(`/callprogress/${props.match.params.activeCallId}/${action}`);
    }

  };

  const callHistoryClick = () => {
    track("call_history", "clicked");
    props.history.push("/history");
  };

  // TODO here is where the magic begins .... check stuff here 
  let userControlStatus = "zero";

  if (callInfo && !!callInfo.transferStatus) {
    userControlStatus = callInfo.transferStatus;
  } else {
    userControlStatus = callInfo && callInfo.activeCallId && callInfo.inprogressCalls && callInfo.inprogressCalls[callInfo.activeCallId] ? callInfo.inprogressCalls[callInfo.activeCallId].userControlStatus : "zero";
  }

  // console.log('fffffffff', userControlStatus, callInfo.activeCallId, callInfo.inprogressCalls, callInfo.inprogressCalls.length > 0);

  return (
    <SoftPhone
      cbCallHistoryClick={callHistoryClick}
      cbRefreshDevices={refreshDevices}
      cbUserAction={userAction}
      userControlStatus={userControlStatus}
      uiState={props.match.params.uiStatus}
      setShowAddCallKeypad={props.setShowAddCallKeypad}
      showAddCallKeypad={props.showAddCallKeypad}
    />
  );

});

callProgress.propTypes = {
  cbUserActionClicked: PropTypes.func,
  cbRefreshDevices: PropTypes.func,
  cbUserAction: PropTypes.func
};


export default callProgress;